import { AllCategories } from './types';

export const categories: AllCategories = {
  OK: {
    name: 'OK',
    value: 'ok',
  },
  WARNING: {
    name: 'Warning',
    value: 'warning',
  },
  CRITICAL: {
    name: 'Critical',
    value: 'critical',
  },
  INFO: {
    name: 'Info',
    value: 'info',
  },
};
